import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl } from '@angular/forms';
import format from 'date-fns/format';
import { ReservationService } from '../reservation.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService, Constants, CredentialsService } from '@app/core';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { PMSIntegrationService } from './pms-integration.service';
import { Subject } from 'rxjs';
import { ClientService } from '@app/core/client.service';
import { ReplaceGuestReservationComponent } from './replace-guest-reservation/replace-guest-reservation.component';
import { addDays, subDays } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface FilterOption {
  id: number;
  label: string;
}
type MealPolicy = 0 | 1 | 2 | 3;

@Component({
  selector: 'app-hotel-reservation',
  templateUrl: './hotel-reservation.component.html',
  styleUrls: ['./hotel-reservation.component.scss']
})
export class HotelReservationComponent implements OnInit, OnDestroy {
  @ViewChild('myTable', { static: false }) table: any;
  subscriptions: Subscription[] = [];
  reservationFormGroup: FormGroup;
  isLoadingAutocomplete: boolean = false;
  restaurants: any = [];
  times: any[] = [];
  incompatibilities: any[] = [];
  areAllTablesFreeAtSelectedTime: boolean = true;
  // breakfastPolicy: MealPolicy = 0;
  // lunchPolicy: MealPolicy = 0;
  // dinnerPolicy: MealPolicy = 0;
  settings: any = Constants.pmsIntegrationSettings;
  breakfastPolicy = this.settings.breakfastPolicy;
  lunchPolicy = this.settings.lunchPolicy;
  dinnerPolicy = this.settings.dinnerPolicy;
  minArrivalDate: Date;
  minDepartureDate: Date;
  tags: any[];
  previousArrivalDate: Date;
  previousDepartureDate: Date;
  stayTimes = [
    { name: `1 ${this.translate.instant('HotelReservations.Hour')}`, value: 60 },
    { name: `1.5  ${this.translate.instant('HotelReservations.Hours')}`, value: 90 },
    { name: `2  ${this.translate.instant('HotelReservations.Hours')}`, value: 120 },
    { name: `2.5  ${this.translate.instant('HotelReservations.Hours')}`, value: 150 },
    { name: `4  ${this.translate.instant('HotelReservations.Hours')}`, value: 240 }
  ];
  private ngUnsubscribe: Subject<any> = new Subject();
  hotelReservations: any = [];
  tableLimit: number = 25;
  copyAllItems: boolean = false;
  defaultTime: string;
  mealTypeMap: { [key: string]: string } = {
    breakfast: this.translate.instant('HotelReservations.Breakfast'),
    lunch: this.translate.instant('HotelReservations.Lunch'),
    dinner: this.translate.instant('HotelReservations.Dinner')
  };
  breakfastCounter: number = 1;
  lunchCounter: number = 1;
  dinnerCounter: number = 1;
  canceledReservations: any = [];
  private destroy$ = new Subject<void>();
  dateBasedFilter: any = Constants.pmsIntegrationSettings.filter;
  dateBasedFilterOptions = [
    { value: 'arrival', label: this.translate.instant('HotelReservations.DateArrival') },
    { value: 'stay', label: this.translate.instant('HotelReservations.DateStay') }
  ];
  mealOptions: { value: string; label: string; color: string }[] = [
    { value: 'FR', label: this.translate.instant('HotelReservations.Breakfast'), color: 'lightsalmon' },
    { value: 'HP', label: this.translate.instant('HotelReservations.HalfBoard'), color: 'lightpink' },
    { value: 'VP', label: this.translate.instant('HotelReservations.FullBoard'), color: 'lightblue' }
  ];

  mealTypeOrder: { [key: string]: number } = {
    dinner: 1,
    lunch: 2,
    breakfast: 3
  };

  allHotelReservations: any = [];
  submitObservable: any;
  dates: any = {
    from: '',
    to: ''
  };
  stayDate: any = moment();
  showErrorMessage: boolean = false;
  pmsIntegrations: any[] = [];
  multipleIntegration: boolean = false;
  loadingHotelRes: boolean = false;
  selectedIntegration: any;
  callPlaced: boolean = false;
  updateReservation: boolean = false;
  showOnlyNewReservations: boolean = false;
  rowExpandedState: boolean[] = [];
  pageSize = 10000;
  currentPage = 1;
  totalPages = 1;
  paginatedReservations: any = [];
  searchTerm: any = '';
  searchMealPlan: any = null;
  allRatePlans: any = [];
  menuOpen = false;
  creds: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private reservationService: ReservationService,
    private snackBar: MatSnackBar,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private pmsIntegrationService: PMSIntegrationService,
    private clientService: ClientService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private credentialsService: CredentialsService
  ) {
    this.translate.onLangChange.subscribe((event: any) => {});
  }

  ngOnInit() {
    this.creds = this.credentialsService.getCredentials();
    this.setDates('thisWeek');
    this.initForm();
    this.getTimes();
    // Load meal/stay settings from DB immediately
    this.getPMSMealSettings();

    // this.subscriptions.push(
    //   this.authService.getActiveClient().subscribe(data => {
    //     this.clientId = data.id;
    //   })
    // );

    // this.minArrivalDate = new Date();
    // this.minDepartureDate = new Date();

    // Fetch all required data before executing route logic
    this.subscriptions.push(
      forkJoin({
        rooms: this.reservationService.getRooms(),
        incompatibilities: this.reservationService.getIncompatibilities(),
        tags: this.reservationService.getTags(),
        allRatePlans: this.reservationService.getPMSProductData()
      }).subscribe(({ rooms, incompatibilities, tags, allRatePlans }) => {
        // Process results
        this.restaurants = rooms.filter((room: any) => room.isActive == 1);
        this.incompatibilities = incompatibilities.data;
        this.tags = tags;
        this.allRatePlans = allRatePlans.success ? allRatePlans.data : [];

        // Check and execute `placeGuest` only after all API calls complete
        const hotelId = this.route.snapshot.paramMap.get('hotelId');
        if (hotelId) {
          this.placeGuest({ hotelId });
        }
      })
    );

    this.subscriptions.push(
      this.reservationService.getPMSDetails().subscribe(
        res => {
          if (res && res.length) {
            this.pmsIntegrations = [
              {
                label: Constants.hotelIntegrations.Oracle,
                showBtn: !!res.find((item: any) => item.hotelSystem === Constants.hotelIntegrations.Oracle),
                onClick: () => this.getHotelReservationOracle()
              },
              {
                label: Constants.hotelIntegrations.ASA,
                showBtn: !!res.find((item: any) => item.hotelSystem === Constants.hotelIntegrations.ASA),
                onClick: () => this.getHotelReservationASA()
              },
              {
                label: Constants.hotelIntegrations.ibelsa,
                showBtn: !!res.find((item: any) => item.hotelSystem === Constants.hotelIntegrations.ibelsa),
                onClick: () => this.getHotelReservationIbelsa()
              },
              {
                label: Constants.hotelIntegrations.Casablanca,
                showBtn: !!res.find((item: any) => item.hotelSystem === Constants.hotelIntegrations.Casablanca),
                onClick: () => this.getHotelReservationCasablanca()
              },
              {
                label: Constants.hotelIntegrations.Sihot,
                showBtn: !!res.find((item: any) => item.hotelSystem === Constants.hotelIntegrations.Sihot),
                onClick: () => this.getHotelReservationSihot()
              }
            ].filter(integration => integration.showBtn); // Remove integrations that are not available

            // Check if there are multiple integrations
            this.multipleIntegration = this.pmsIntegrations.length > 1;
          } else {
            this.pmsIntegrations = [];
            this.multipleIntegration = false;
          }
        },
        err => {
          this.pmsIntegrations = [];
          this.multipleIntegration = false;
        }
      )
    );

    this.subscriptions.push(
      this.reservationService.getAllHotelReservations().subscribe(
        res => {
          if (res) {
            // this.allHotelReservations = res.map((item: any) => item.hotelReservation.bookingNumber);
            this.allHotelReservations = res;
          }
        },
        err => {
          this.allHotelReservations = [];
        }
      )
    );

    this.getPMSProductData();
  }

  onSelectIntegration(selectedIntegration: any) {
    this.selectedIntegration = selectedIntegration;
  }

  triggerLoading(index: number) {
    this.checkDateFilterSetDate();
    this.loadingHotelRes = true;
    this.pmsIntegrations[index].onClick();
    this.reservationFormGroup.get('hotelSystem').setValue(this.pmsIntegrations[index].label);
    this.getPMSMealSettings();
  }

  createNumValues(number: number): any[] {
    const items: any[] = [];
    for (let i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }

  onRowIndexClick(i: number) {
    this.rowExpandedState[i] = !this.rowExpandedState[i];
  }

  // for storing in database we need to convert this in min
  private getRowStayMinutes(row: any): number {
    let rowVal = null;
    if (row && row.reservationStayTime) {
      rowVal = row.reservationStayTime.value != null ? row.reservationStayTime.value : row.reservationStayTime;
    }
    const mainCtrl = this.reservationFormGroup.get('stayTime');
    const main = mainCtrl ? mainCtrl.value : null;
    const mainVal = main && main.value != null ? main.value : main;
    return Number(rowVal != null ? rowVal : mainVal != null ? mainVal : this.settings.stayTime);
  }

  addNewReservationGroup(date: Date, mealType: any, existingReservation: any = {}): FormGroup {
    const group = this.formBuilder.group({
      date: [date, Validators.required],
      time: [existingReservation.time || null, Validators.required],
      listOfTimes: [this.times, Validators.required],
      listOfRestaurants: [this.restaurants, Validators.required],
      restaurant: [existingReservation.restaurant || null],
      table: [[]],
      listOfTables: [[]],
      errorMessage: [''],
      isEditable: [false],
      mealType: [mealType, Validators.required],
      resIndex: [],
      tableLoader: false,
      exempt: [false],
      reservationId: [existingReservation.id || ''],
      // reservationStayTime: [existingReservation.stayTime || this.settings.stayTime],
      reservationStayTime: [existingReservation.stayTime || null],
      reservationTags: [existingReservation.tags]
    });
    // Watch for changes in `exempt`
    group.get('exempt').valueChanges.subscribe(exempt => {
      if (exempt) {
        group.get('date').clearValidators();
        group.get('time').clearValidators();
        group.get('listOfTimes').clearValidators();
        group.get('listOfRestaurants').clearValidators();
        // group.get('restaurant').clearValidators();
        // group.get('table').clearValidators();
        group.get('mealType').clearValidators();
      } else {
        group.get('date').setValidators(Validators.required);
        group.get('time').setValidators(Validators.required);
        group.get('listOfTimes').setValidators(Validators.required);
        group.get('listOfRestaurants').setValidators(Validators.required);
        // group.get('restaurant').setValidators(Validators.required);
        // group.get('table').setValidators(Validators.required);
        group.get('mealType').setValidators(Validators.required);
      }
      group.get('date').updateValueAndValidity({ emitEvent: false });
      group.get('time').updateValueAndValidity({ emitEvent: false });
      group.get('listOfTimes').updateValueAndValidity({ emitEvent: false });
      group.get('listOfRestaurants').updateValueAndValidity({ emitEvent: false });
      // group.get('restaurant').updateValueAndValidity({ emitEvent: false });
      // group.get('table').updateValueAndValidity({ emitEvent: false });
      group.get('mealType').updateValueAndValidity({ emitEvent: false });
    });

    return group;
  }

  addNewReservationFormAtIndex(date: Date, index: number, mealType: any = '') {
    (<FormArray>this.reservationForm).insert(index, this.addNewReservationGroup(date, mealType));
  }

  deleteReservationFromArray(index: number) {
    (<FormArray>this.reservationForm).removeAt(index);
  }

  updateOnlyHotelInfo() {
    if (this.reservationFormGroup.valid) {
      this.processReservations(true);
    } else {
      this.snackBar.open(this.translate.instant('HotelReservations.CheckYourDetails'), '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }
  }

  createReservation(): void {
    // if everything is ok create new reservations
    if (this.reservationFormGroup.valid) {
      this.processReservations();
    }

    // check if input form is invalid without reservations form
    Object.keys(this.reservationFormGroup.controls).forEach(controlName => {
      this.reservationFormGroup.controls[controlName].markAsTouched();
    });

    if (
      !this.reservationFormGroup.controls.name.valid ||
      !this.reservationFormGroup.controls.roomNumber.valid ||
      !this.reservationFormGroup.controls.reservationNumber.valid ||
      !this.reservationFormGroup.controls.arrivalDate.valid ||
      !this.reservationFormGroup.controls.departureDate.valid ||
      !this.reservationFormGroup.controls.stayTime.valid
    ) {
      this.snackBar.open(this.translate.instant('HotelReservations.CheckYourDetails'), '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }

    // if all input fields are valid except list of reservations show this confirm dialog
    if (!this.reservationFormGroup.controls.reservations.valid) {
      // Loop through all form controls and log the invalid ones
      // for (const controlName in this.reservationFormGroup.controls) {
      //   const control = this.reservationFormGroup.controls[controlName];

      //   if (control.invalid) {
      //     console.log(`❌ ${controlName} is invalid`);
      //     console.log(`   ➡ Current Value:`, control.value);

      //     // Check and log specific validation errors
      //     if (control.errors) {
      //       Object.keys(control.errors).forEach(errorKey => {
      //         console.log(`   🚨 Error: ${errorKey} -`, control.errors[errorKey]);
      //       });
      //     }

      //     // If it's a FormArray (like reservations), check its children
      //     if (control instanceof FormArray) {
      //       console.log(`   🔎 Inspecting FormArray: ${controlName}`);
      //       control.controls.forEach((group, index) => {
      //         if (group.invalid) {
      //           console.log(`   ❌ reservations[${index}] is invalid`);
      //           console.log(`      ➡ Current Value:`, group.value);

      //           if (group.errors) {
      //             Object.keys(group.errors).forEach(errorKey => {
      //               console.log(`      🚨 Error: ${errorKey} -`, group.errors[errorKey]);
      //             });
      //           }

      //           // Check each FormGroup inside the FormArray
      //           if (group instanceof FormGroup) {
      //             Object.keys(group.controls).forEach(childName => {
      //               const childControl = group.get(childName);
      //               if (childControl && childControl.invalid) {
      //                 console.log(`      ❌ Field '${childName}' inside reservations[${index}] is invalid`);
      //                 console.log(`         ➡ Current Value:`, childControl.value);
      //                 if (childControl.errors) {
      //                   Object.keys(childControl.errors).forEach(errorKey => {
      //                     console.log(`         🚨 Error: ${errorKey} -`, childControl.errors[errorKey]);
      //                   });
      //                 }
      //               }
      //             });
      //           }
      //         }
      //       });
      //     }
      //   } else {
      //     console.log(`✅ ${controlName} is valid`);
      //   }
      // }
      const modalRef = this.modalService.open(ConfirmModalComponent);
      modalRef.componentInstance.title = this.translate.instant('HotelReservations.NotAllReservationsFulfilled');
      modalRef.componentInstance.message = this.translate.instant('HotelReservations.DaysWithoutReservation');
      modalRef.componentInstance.showInfo = false;
      modalRef.componentInstance.buttonText = this.translate.instant('HotelReservations.Yes');
      modalRef.result.then(
        result => {
          if (result === 'ok') {
            this.processReservations();
          }
        },
        () => {}
      );
    }
  }

  searchFreeTables(index: number, previousTables: any = []) {
    const selectedRestaurantId = this.reservationForm.value[index].restaurant;
    const time = this.reservationForm.value[index].time;
    if (selectedRestaurantId && time) {
      this.updateFormGroupValue('reservations', { tableLoader: true }, index);
      if (this.reservationForm.value[index].table) {
        this.reservationForm.controls[index].get('table').patchValue(null, { emitEvent: false });
        this.updateFormGroupValue('reservations', { listOfTables: [] }, index);
        this.updateFormGroupValue('reservations', { errorMessage: '' }, index);
      }
      const data = this.reservationFormGroup.value;
      const res = this.reservationForm.value[index];
      const stayMin = this.getRowStayMinutes(res);
      this.subscriptions.push(
        this.reservationService
          .checkFreeTables(
            res.date,
            time,
            data.numberOfPersons,
            stayMin,
            true,
            true,
            res.reservationId || '',
            selectedRestaurantId
          )
          .subscribe(response => {
            if (response) {
              const selectedRestaurant = response[0];
              this.fillTableArrayWithAvailableTables(selectedRestaurant, index, previousTables);
            }
          })
      );
    }
  }

  fillTableArrayWithAvailableTables(selectedRestaurant: any, index: number, previousTables: any): void {
    const tables: any[] = [];
    const onlyTables: any[] = [];
    if (selectedRestaurant && Array.isArray(selectedRestaurant.tables)) {
      for (const element of selectedRestaurant.tables) {
        if (!element.isRoom) {
          let isNotAvailable = false;
          let msg = this.translate.instant('HotelReservations.TableIsFree');

          if (element.isFree === false) {
            isNotAvailable = true;
            msg = this.translate.instant('HotelReservations.TableIsOccupied');
          } else if (parseInt(this.reservationFormGroup.get('numberOfPersons').value, 10) > element.seats) {
            isNotAvailable = true;
            msg = `Max ${element.seats} ${this.translate.instant('HotelReservations.Persons')}`;
          }
          if (!element.isCombined) {
            tables.push({ table: element, isNotAvailable, msg });
            onlyTables.push(element);
          }
        }
      }
    }
    this.updateFormGroupValue('reservations', { listOfTables: tables || [] }, index);
    if (previousTables && previousTables.length > 0 && tables.length > 0) {
      const availableTables = onlyTables.filter(
        (element: any) =>
          element.isFree && parseInt(this.reservationFormGroup.get('numberOfPersons').value) <= element.seats
      );

      // Check if all previously selected tables exist in available tables
      const allTablesExist = previousTables.every((tableId: any) =>
        availableTables.some((item: any) => item.id === tableId)
      );

      if (!allTablesExist) {
        this.updateFormGroupValue(
          'reservations',
          { errorMessage: `${this.translate.instant('HotelReservations.TablesNotFree')}` },
          index
        );
      } else {
        setTimeout(() => {
          this.updateFormGroupValue('reservations', { table: previousTables }, index);
        }, 1000); // 1 seconds delay
        this.updateFormGroupValue('reservations', { errorMessage: '' }, index);
      }
    }
    this.updateFormGroupValue('reservations', { tableLoader: false }, index);
  }

  onNumberOfPersonsChange() {
    for (let i = 0; i < this.reservationForm.value.length; i++) {
      const element = this.reservationForm.value[i];
      if (element.restaurant) {
        this.searchFreeTables(i);
      }
    }
  }

  updateFormGroupValue(formGroupName: string, value: any, index: number): void {
    (<FormArray>this.reservationFormGroup.controls[formGroupName]).at(index).patchValue(value, { emitEvent: false });
  }

  processReservations(updateOnlyHotelInfo = false): void {
    const fg = this.reservationFormGroup.value;
    const reservations: any[] = [];
    for (let i = 0; i < this.reservationForm.value.length; i++) {
      const row = this.reservationForm.value[i];
      // if (row.date && row.time && (row.restaurant || row.reservationId)) {
      if (row.date && row.time) {
        const day = format(row.date, 'YYYY-MM-DD');
        const reservedFor = `${day}T${row.time}:00`;
        reservations.push({
          reservedFor: reservedFor,
          room: row.restaurant,
          table: row.table || [],
          reservationTags: row.reservationTags || '',
          reservationStayTime: this.getRowStayMinutes(row),
          reservationId: row.reservationId || ''
        });
      }
    }
    if (reservations.length === 0) {
      this.snackBar.open(this.translate.instant('HotelReservations.MinOneReservation'), '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }

    const stayTimeVal =
      fg.stayTime && typeof fg.stayTime === 'object' && fg.stayTime.value != null ? fg.stayTime.value : fg.stayTime;

    const toIso = (d: any) => (d ? new Date(d).toISOString() : null);

    const reservation = {
      name: fg.name || '',
      roomNumber: fg.roomNumber || '',
      reservationNumber: fg.reservationNumber || '',
      arrivalDate: toIso(fg.arrivalDate),
      departureDate: toIso(fg.departureDate),
      selectedTags: fg.selectedTags || [],
      numberOfPersons: fg.numberOfPersons != null ? fg.numberOfPersons : 1,
      numberOfKids: fg.numberOfKids != null ? fg.numberOfKids : 0,
      numberOfHighChairs: fg.numberOfHighChairs != null ? fg.numberOfHighChairs : 0,
      incompatibilities: fg.incompatibilities || null,
      notes: fg.notes || '',
      reservations: reservations,
      stayTime: stayTimeVal != null ? stayTimeVal : 90,
      firstName: fg.firstName || '',
      email: fg.email || '',
      phone: fg.phone || '',
      board: fg.board || '',
      groupTags: fg.groupTags || '',
      hotelSystem: fg.hotelSystem || null,
      guestNotes: fg.guestNotes || null,
      bookingId: fg.bookingId || null,
      hotelId: fg.hotelId || null,
      guestId: fg.guestId || null,
      canceledReservations: this.canceledReservations || [],
      updateOnlyHotelInfo: updateOnlyHotelInfo,
      createdAt: new Date().toISOString()
    };

    this.submitObservable = this.subscriptions.push(
      this.reservationService.addMultipleReservations(reservation).subscribe(
        (res: any) => {
          if (res) {
            this.callPlaced = false;
            this.snackBar.open(this.translate.instant('HotelReservations.BookingSuccess'), '', {
              duration: 3000,
              panelClass: ['snackbar-success']
            });
            const foundPlaceRes = this.hotelReservations.find(
              (item: any) =>
                item.reservationNo.toString() === this.reservationFormGroup.value.reservationNumber.toString()
            );
            if (foundPlaceRes) {
              foundPlaceRes.hotelId = res.id;
              this.hotelReservations = [...this.hotelReservations];
              this.setHotelPaginationData();
              this.initForm();
            }
          }
        },
        err => {
          if (err.status === 422) {
            this.snackBar.open(err.error.msg, '', {
              duration: 3000,
              panelClass: ['snackbar-error']
            });
          }
        }
      )
    );
  }

  initForm(): void {
    this.reservationFormGroup = this.formBuilder.group({
      name: [null, Validators.required],
      roomNumber: [null, Validators.required],
      reservationNumber: ['', Validators.required],
      arrivalDate: [null, Validators.required],
      departureDate: [null, Validators.required],
      stayTime: new FormControl(null, Validators.required),
      selectedTags: [[]],
      numberOfPersons: [1, Validators.required],
      numberOfKids: [0, Validators.required],
      numberOfHighChairs: [0, Validators.required],
      incompatibilities: [null],
      notes: [null],
      reservations: this.formBuilder.array([]),
      board: [null, Validators.required],
      firstName: [null],
      email: [null],
      phone: [null],
      groupTags: [null],
      hotelSystem: [null],
      guestNotes: [null],
      bookingId: [null],
      hotelId: [null],
      guestId: [null]
    });
  }

  get reservationForm() {
    return <FormArray>this.reservationFormGroup.get('reservations');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  // Function to validate To and From date
  validateDateRange() {
    this.showErrorMessage = false;
    if (moment(this.dates.from).isAfter(this.dates.to)) {
      this.showErrorMessage = true;
    }
  }

  setDates(type: string) {
    if (type === 'thisWeek') {
      const date = moment();
      this.dates.from = date.startOf('week');
      this.dates.to = moment(this.dates.from).endOf('week');
    } else if (type === 'nextWeek') {
      const date = moment().add(1, 'week');
      this.dates.from = date.startOf('week');
      this.dates.to = moment(this.dates.from).endOf('week');
    } else if (type === 'next2Weeks') {
      const date = moment().add(1, 'week');
      this.dates.from = date.startOf('week');
      this.dates.to = moment(this.dates.from)
        .add(1, 'week')
        .endOf('week');
    } else if (type === 'nextMonth') {
      const date = moment().add(1, 'month');
      this.dates.from = date.startOf('month');
      this.dates.to = moment(this.dates.from).endOf('month');
    } else if (type === 'next2Months') {
      const date = moment().add(1, 'month');
      this.dates.from = date.startOf('month');
      this.dates.to = moment(this.dates.from)
        .add(1, 'month')
        .endOf('month');
    } else if (type === 'next6Months') {
      const date = moment().add(1, 'month');
      this.dates.from = date.startOf('month');
      this.dates.to = moment(this.dates.from)
        .add(5, 'months')
        .endOf('month');
    }
  }

  getHotelReservationOracle() {
    this.fetchingStartedHotelRes();
    this.subscriptions.push(
      this.pmsIntegrationService
        .getHotelReservationsOracle(this.dates.from, this.dates.to, this.dateBasedFilter)
        .subscribe(
          res => {
            if (res) {
              console.log('Oracle1', res);
              for (let item of res) {
                if (
                  item.reservationStatus &&
                  item.reservationStatus !== 'CheckedOut' &&
                  item.reservationStatus !== 'Cancelled'
                ) {
                  let packagesCode = '';
                  if (item.packages && item.packages[0]) {
                    packagesCode = item.packages && item.packages[0] ? item.packages[0].packageCode : '';
                    console.log(
                      'packages',
                      packagesCode,
                      item.packages[0].packageHeaderType.primaryDetails.description,
                      item.packages
                    );
                  }

                  let guestNote = '';
                  if (item.comments && item.comments[0] && item.comments[0].comment) {
                    guestNote = item.comments[0].comment.text.value;
                  }

                  if (
                    item.preferenceCollection &&
                    item.preferenceCollection[0] &&
                    item.preferenceCollection[0].preference
                  ) {
                    guestNote += item.preferenceCollection[0].preference.map((p: any) => p.description).join(', ');
                  }

                  let hotelReservation: any = {};
                  hotelReservation.reservationNo = item.reservationIdList[0].id;
                  hotelReservation.arrivalDate = item.roomStay.arrivalDate;
                  hotelReservation.departureDate = item.roomStay.departureDate;
                  hotelReservation.guestCount = item.roomStay.adultCount + item.roomStay.childCount;
                  // hotelReservation.guestCount = item.roomStay.adultCount;
                  hotelReservation.childCount = item.roomStay.childCount;
                  hotelReservation.roomNo = item.roomStay.roomId;
                  hotelReservation.guestInfo = {
                    name: item.reservationGuest.surname,
                    firstName: item.reservationGuest.givenName,
                    email: item.reservationGuest.email,
                    phone: item.reservationGuest.phoneNumber,
                    guestNotes: guestNote
                  };
                  let ratePlanCode = item.roomStay.ratePlanCode ? item.roomStay.ratePlanCode : '';
                  hotelReservation.reservationInfo = {
                    RatePlanCode: ratePlanCode
                  };

                  hotelReservation.board = this.replaceBoardcode(ratePlanCode, Constants.hotelIntegrations.Oracle);

                  const foundReservation = this.allHotelReservations.find(
                    (res: any) =>
                      res.hotelReservation.bookingNumber.toString() === hotelReservation.reservationNo.toString()
                  );
                  hotelReservation.hotelId = foundReservation ? foundReservation.hotelReservation.id : null;
                  // this.hotelReservations.push(hotelReservation);
                  if (this.dateBasedFilter == 'stay') {
                    if (this.checkIfStayDate(hotelReservation)) {
                      this.hotelReservations.push(hotelReservation);
                    }
                  } else {
                    this.hotelReservations.push(hotelReservation);
                  }
                }
              }
            }
            console.log('Oracle2', this.hotelReservations);
            this.setHotelPaginationData();
          },
          err => {
            this.setHotelPaginationData();
            // if (err && err.error.error == "Request failed with status code 502") {
            //   this.pmsIntegrationService.fetchAccessToken();
            // }
            const errMsg =
              err && err.error && err.error.msg
                ? err.error.msg
                : `${this.translate.instant('HotelReservations.SomethingWentWrong')}`;
            this.snackBar.open(errMsg, '', {
              duration: 2000,
              panelClass: ['snackbar-error']
            });
          }
        )
    );
  }

  getHotelReservationASA() {
    this.fetchingStartedHotelRes();
    this.subscriptions.push(
      this.pmsIntegrationService
        .getHotelReservationsASA(this.dates.from, this.dates.to, this.dateBasedFilter)
        .subscribe(
          res => {
            if (res) {
              console.log('ASA1', res);
              for (let item of res) {
                if (!item.type || (item.type != 'contingent' && item.type != 'option')) {
                  let hotelReservation: any = {};
                  hotelReservation.reservationNo = item.number;
                  const roomNumbers = item.roomReservations.roomReservation.map(
                    (reservation: any) => reservation.room.number
                  );

                  const roomNumbersString = roomNumbers.join(',');
                  const roomReservations = item.roomReservations.roomReservation[0];

                  hotelReservation.guestCount = 0;
                  hotelReservation.childCount = 0;
                  for (let singleRoomReservation of item.roomReservations.roomReservation) {
                    hotelReservation.guestCount +=
                      (singleRoomReservation.adults ? singleRoomReservation.adults : 0) +
                      (singleRoomReservation.children ? singleRoomReservation.children : 0);
                    hotelReservation.childCount += singleRoomReservation.children ? singleRoomReservation.children : 0;
                  }

                  const boardCode = roomReservations.boardCode;
                  hotelReservation.arrivalDate = roomReservations.arrival;
                  hotelReservation.departureDate = roomReservations.departure;

                  hotelReservation.roomNo = roomNumbersString;
                  const annotations = [
                    // roomReservations.diningRoomAnnotation,
                    roomReservations.kitchenAnnotation,
                    roomReservations.diningAnnotation
                  ]
                    .filter(Boolean)
                    .join('\n');

                  if (annotations) {
                    hotelReservation.notes = annotations;
                  }

                  const guestName = roomReservations.guestName ? roomReservations.guestName.split(' ') : '';

                  let guestAnnotations = '';
                  if (
                    roomReservations.roomGuests &&
                    roomReservations.roomGuests.roomGuest &&
                    roomReservations.roomGuests.roomGuest.length > 0
                  ) {
                    guestAnnotations = roomReservations.roomGuests.roomGuest
                      .map((guest: any) => [
                        // guest.diningRoomAnnotation,
                        guest.kitchenAnnotation,
                        guest.diningAnnotation
                      ])
                      .flat()
                      .filter(Boolean)
                      .join('\n');
                  }
                  hotelReservation.guestInfo = {
                    name: item.guest ? item.guest.lastName : guestName ? guestName[0] : '',
                    firstName: item.guest ? item.guest.firstName : guestName ? guestName[1] : '',
                    email: item.guest ? item.guest.email : '',
                    phone: item.guest ? item.guest.telephone : '',
                    guestNotes: guestAnnotations
                  };

                  hotelReservation.reservationInfo = {
                    BoardCode: boardCode ? boardCode : '',
                    RatePlanCode: roomReservations.ratePlanCode ? roomReservations.ratePlanCode : ''
                  };

                  hotelReservation.board = this.replaceBoardcode(boardCode, Constants.hotelIntegrations.ASA);

                  const foundReservation = this.allHotelReservations.find(
                    (res: any) =>
                      res.hotelReservation.bookingNumber.toString() === hotelReservation.reservationNo.toString()
                  );

                  hotelReservation.hotelId = foundReservation ? foundReservation.hotelReservation.id : null;

                  hotelReservation.bookingId = item.id;
                  this.hotelReservations.push(hotelReservation);
                }
              }
            }
            this.hotelReservations = [...this.hotelReservations];
            console.log('ASA2', this.hotelReservations);
            this.setHotelPaginationData();
          },
          err => {
            this.setHotelPaginationData();
            const errMsg =
              err && err.error && err.error.msg
                ? err.error.msg
                : `${this.translate.instant('HotelReservations.SomethingWentWrong')}`;
            this.snackBar.open(errMsg, '', {
              duration: 2000,
              panelClass: ['snackbar-error']
            });
          }
        )
    );
  }

  getHotelReservationIbelsa() {
    this.fetchingStartedHotelRes();
    this.subscriptions.push(
      this.pmsIntegrationService
        .getHotelReservationIbelsa(this.dates.from, this.dates.to, this.dateBasedFilter)
        .subscribe(
          res => {
            if (res) {
              console.log('Ibelsa1', res);
              for (let item of res) {
                if (item.room_stays && item.room_stays.length && item.status == 'BOOKED') {
                  let hotelReservation: any = {};
                  hotelReservation.reservationNo = item.id;
                  const roomNumbers = item.room_stays.map((room: any) => room.room_name);
                  const roomNumbersString = roomNumbers.join(',');
                  hotelReservation.arrivalDate = item.starts_at;
                  hotelReservation.departureDate = item.ends_at;
                  hotelReservation.guestCount = item.person_count;
                  hotelReservation.roomNo = roomNumbersString;
                  hotelReservation.notes =
                    item.invoice_items && item.invoice_items[0] ? item.invoice_items[0].name : '';
                  hotelReservation.guestInfo = {
                    name: item.guest ? item.guest.lastname : '',
                    firstName: item.guest ? item.guest.firstname : '',
                    email: item.guest ? item.guest.email : '',
                    phone: item.guest ? item.guest.mobilephone : '',
                    guestNotes: ''
                  };

                  hotelReservation.reservationInfo = {
                    RatePlanCode: item.rate_name
                  };
                  hotelReservation.board = this.replaceBoardcode(item.rate_name, Constants.hotelIntegrations.ibelsa);

                  const foundReservation = this.allHotelReservations.find(
                    (res: any) =>
                      res.hotelReservation.bookingNumber.toString() === hotelReservation.reservationNo.toString()
                  );
                  hotelReservation.hotelId = foundReservation ? foundReservation.hotelReservation.id : null;

                  // this.hotelReservations.push(hotelReservation);
                  if (this.dateBasedFilter == 'arrival') {
                    if (this.checkIfArrivalDate(hotelReservation)) {
                      this.hotelReservations.push(hotelReservation);
                    }
                  } else {
                    this.hotelReservations.push(hotelReservation);
                  }
                }
              }
            }
            this.hotelReservations = [...this.hotelReservations];
            console.log('Ibelsa2', this.hotelReservations);
            this.setHotelPaginationData();
          },
          err => {
            this.setHotelPaginationData();
            const errMsg =
              err && err.error && err.error.msg
                ? err.error.msg
                : `${this.translate.instant('HotelReservations.SomethingWentWrong')}`;
            this.snackBar.open(errMsg, '', {
              duration: 2000,
              panelClass: ['snackbar-error']
            });
          }
        )
    );
  }

  getHotelReservationCasablancaOld() {
    this.fetchingStartedHotelRes();
    this.subscriptions.push(
      this.pmsIntegrationService
        .getHotelReservationCasablanca(this.dates.from, this.dates.to, this.dateBasedFilter)
        .subscribe(
          res => {
            if (res) {
              console.log('Casablanca1', res);
              for (let item of res) {
                if (item.$.ResStatus === 'Reserved') {
                  let hotelReservation: any = {};

                  // Extract item number
                  const uniqueID = item.UniqueID.find((id: any) => id.$.Type === '14');
                  hotelReservation.reservationNo = uniqueID ? uniqueID.$.ID : '';
                  // hotelReservation.reservationNo = item.ResGlobalInfo && item.ResGlobalInfo.HotelReservationIDs ?  item.ResGlobalInfo.HotelReservationIDs.HotelReservationID[0].$.ResID_Type: '';

                  hotelReservation.notes =
                    item.ResGlobalInfo &&
                    item.ResGlobalInfo.Comments &&
                    item.ResGlobalInfo.Comments.Comment &&
                    item.ResGlobalInfo.Comments.Comment.Text
                      ? item.ResGlobalInfo.Comments.Comment.Text.replace(/\r\n/g, '\n')
                      : '';

                  // Extract room numbers
                  const roomStays = Array.isArray(item.RoomStays.RoomStay)
                    ? item.RoomStays.RoomStay
                    : [item.RoomStays.RoomStay];
                  const roomNumbers = roomStays.map((roomStay: any) => roomStay.RoomTypes.RoomType.$.RoomID);
                  hotelReservation.roomNo = roomNumbers.join(',');

                  // Extract dates
                  const timeSpan = roomStays[0].TimeSpan.$;
                  hotelReservation.arrivalDate = timeSpan.Start;
                  hotelReservation.departureDate = timeSpan.End;

                  // Extract guest count
                  // const guestCount =  roomStays[0].GuestCounts && roomStays[0].GuestCounts.GuestCount && roomStays[0].GuestCounts.GuestCount.$ ? roomStays[0].GuestCounts.GuestCount.$.Count : 0;
                  // hotelReservation.guestCount = guestCount;

                  let guestCount = 0;
                  let childCount = 0;
                  for (let roomStay of roomStays) {
                    if (roomStay.GuestCounts && roomStay.GuestCounts.GuestCount) {
                      const guestData = roomStay.GuestCounts.GuestCount;
                      if (Array.isArray(guestData)) {
                        guestCount += guestData.reduce((sum, guest) => {
                          const count = guest.$.Count ? parseInt(guest.$.Count, 10) : 0;
                          const ageCode = guest.$.AgeQualifyingCode;
                          if (ageCode === '8') {
                            childCount += count;
                          }
                          return sum + count;
                        }, 0);
                      } else if (guestData.$ && guestData.$.Count) {
                        const count = parseInt(guestData.$.Count, 10);
                        guestCount += count;

                        if (guestData.$.AgeQualifyingCode === '8') {
                          childCount += count;
                        }
                      }
                    }
                  }
                  // if (roomStays[0].GuestCounts && roomStays[0].GuestCounts.GuestCount) {
                  //   const guestData = roomStays[0].GuestCounts.GuestCount;
                  //   if (Array.isArray(guestData)) {
                  //     guestCount = guestData.reduce(
                  //       (sum, guest) => sum + (guest.$.Count ? parseInt(guest.$.Count, 10) : 0),
                  //       0
                  //     );
                  //   } else if (guestData.$ && guestData.$.Count) {
                  //     guestCount = parseInt(guestData.$.Count, 10);
                  //   }
                  // }

                  hotelReservation.guestCount = guestCount;
                  hotelReservation.childCount = childCount;
                  // Extract guest information
                  if (item.ResGlobalInfo && item.ResGlobalInfo.Profiles) {
                    const guestProfile = item.ResGlobalInfo.Profiles.ProfileInfo.Profile.Customer;
                    const comment = item.ResGlobalInfo.Profiles.ProfileInfo.Profile.Comments;
                    let guestNotes;
                    if (comment && comment.Comment && comment.Comment.$ && comment.Comment.$.Name === 'Service') {
                      guestNotes = comment.Comment.Text;
                    }
                    hotelReservation.guestInfo = {
                      name: guestProfile.PersonName.Surname || '',
                      firstName: guestProfile.PersonName.GivenName || '',
                      email: guestProfile.Email ? guestProfile.Email._ : '',
                      phone:
                        guestProfile.Telephone &&
                        guestProfile.Telephone[0] &&
                        guestProfile.Telephone[0].$ &&
                        guestProfile.Telephone[0].$.PhoneNumber != '0049'
                          ? guestProfile.Telephone[0].$.PhoneNumber
                          : '',
                      guestNotes: guestNotes ? guestNotes : ''
                    };
                    if (guestNotes) {
                      console.log('guestNotes', guestNotes, hotelReservation.guestInfo);
                    }
                  }
                  let ratePlanCode = '';
                  if (roomStays[0].RoomRates && roomStays[0].RoomRates.RoomRate) {
                    const roomRate = roomStays[0].RoomRates.RoomRate;
                    if (Array.isArray(roomRate)) {
                      ratePlanCode = roomRate[0].$.RatePlanCode;
                    } else if (roomRate.$.RatePlanCode) {
                      ratePlanCode = roomRate.$.RatePlanCode;
                    }
                  }
                  hotelReservation.reservationInfo = {
                    RatePlanCode: ratePlanCode ? ratePlanCode : ''
                  };

                  hotelReservation.board = this.replaceBoardcode(ratePlanCode, Constants.hotelIntegrations.Casablanca);

                  const foundReservation = this.allHotelReservations.find(
                    (res: any) =>
                      res.hotelReservation.bookingNumber.toString() === hotelReservation.reservationNo.toString()
                  );
                  hotelReservation.hotelId = foundReservation ? foundReservation.hotelReservation.id : null;

                  this.hotelReservations.push(hotelReservation);
                }
              }
            }
            this.hotelReservations = [...this.hotelReservations];
            console.log('Casablanca2', this.hotelReservations);
            this.setHotelPaginationData();
          },
          err => {
            this.setHotelPaginationData();
            const errMsg =
              err && err.error && err.error.msg
                ? err.error.msg
                : `${this.translate.instant('HotelReservations.SomethingWentWrong')}`;
            this.snackBar.open(errMsg, '', {
              duration: 2000,
              panelClass: ['snackbar-error']
            });
          }
        )
    );
  }

  getHotelReservationCasablanca() {
    this.fetchingStartedHotelRes();
    this.subscriptions.push(
      this.pmsIntegrationService
        .getHotelReservationCasablanca(this.dates.from, this.dates.to, this.dateBasedFilter)
        .subscribe(
          res => {
            if (res) {
              for (let item of res) {
                if (item.$.ResStatus === 'Reserved' || item.$.ResStatus === 'In-house') {
                  let hotelReservation: any = {};

                  // Extract reservation number
                  const uniqueID = item.UniqueID.find((id: any) => id.$.Type === '14');
                  hotelReservation.reservationNo = uniqueID ? uniqueID.$.ID : '';

                  // Extract notes
                  // hotelReservation.notes =
                  //   item &&
                  //   item.ResGlobalInfo &&
                  //   item.ResGlobalInfo.Comments &&
                  //   item.ResGlobalInfo.Comments.Comment &&
                  //   item.ResGlobalInfo.Comments.Comment.Text
                  //     ? item.ResGlobalInfo.Comments.Comment.Text.replace(/\r\n/g, '\n')
                  //     : '';

                  // Extract guest information
                  if (
                    item.ResGlobalInfo &&
                    item.ResGlobalInfo.Profiles &&
                    item.ResGlobalInfo.Profiles.ProfileInfo &&
                    item.ResGlobalInfo.Profiles.ProfileInfo.Profile &&
                    item.ResGlobalInfo.Profiles.ProfileInfo.Profile.Customer
                  ) {
                    const guestProfile = item.ResGlobalInfo.Profiles.ProfileInfo.Profile.Customer;
                    const comment = item.ResGlobalInfo.Profiles.ProfileInfo.Profile.Comments;
                    let guestNotes;
                    if (comment && comment.Comment && comment.Comment.$ && comment.Comment.$.Name === 'Service') {
                      guestNotes = comment.Comment.Text;
                    }

                    hotelReservation.guestInfo = {
                      name:
                        guestProfile.PersonName && guestProfile.PersonName.Surname
                          ? guestProfile.PersonName.Surname
                          : '',
                      firstName:
                        guestProfile.PersonName && guestProfile.PersonName.GivenName
                          ? guestProfile.PersonName.GivenName
                          : '',
                      email: guestProfile.Email && guestProfile.Email._ ? guestProfile.Email._ : '',
                      phone:
                        guestProfile.Telephone &&
                        guestProfile.Telephone[0] &&
                        guestProfile.Telephone[0].$ &&
                        guestProfile.Telephone[0].$.PhoneNumber !== '0049'
                          ? guestProfile.Telephone[0].$.PhoneNumber
                          : '',
                      guestNotes: guestNotes ? guestNotes : ''
                    };
                  }

                  // Extract room stays
                  const roomStays = Array.isArray(item.RoomStays.RoomStay)
                    ? item.RoomStays.RoomStay
                    : [item.RoomStays.RoomStay];

                  // Check if rooms have different dates or rate plans
                  let runMultiple = false;
                  const baseTimeSpan =
                    roomStays[0] && roomStays[0].TimeSpan && roomStays[0].TimeSpan.$ ? roomStays[0].TimeSpan.$ : null;

                  let baseRatePlanCode = '';
                  const baseRoomRate = roomStays[0] && roomStays[0].RoomRates && roomStays[0].RoomRates.RoomRate;
                  if (baseRoomRate) {
                    baseRatePlanCode = Array.isArray(baseRoomRate)
                      ? baseRoomRate[0].$.RatePlanCode
                      : baseRoomRate.$.RatePlanCode;
                  }

                  for (let i = 1; i < roomStays.length; i++) {
                    const ts =
                      roomStays[i] && roomStays[i].TimeSpan && roomStays[i].TimeSpan.$ ? roomStays[i].TimeSpan.$ : null;

                    const rr = roomStays[i] && roomStays[i].RoomRates && roomStays[i].RoomRates.RoomRate;
                    const rpc = Array.isArray(rr) ? rr[0].$.RatePlanCode : rr && rr.$ ? rr.$.RatePlanCode : '';

                    if (
                      ts &&
                      (ts.Start !== baseTimeSpan.Start || ts.End !== baseTimeSpan.End || rpc !== baseRatePlanCode)
                    ) {
                      runMultiple = true;
                      break;
                    }
                  }

                  if (runMultiple) {
                    // Handle each roomStay separately
                    for (let roomStay of roomStays) {
                      const reservation = { ...hotelReservation };
                      let guestCount = 0;
                      let childCount = 0;
                      const childAgesMap: Record<number, number> = {}; // { age: count }

                      const guestData = roomStay.GuestCounts && roomStay.GuestCounts.GuestCount;

                      // if (guestData) {
                      //   if (Array.isArray(guestData)) {
                      //     guestCount = guestData.reduce((sum, guest) => {
                      //       const count = guest.$.Count ? parseInt(guest.$.Count, 10) : 0;
                      //       if (guest.$.AgeQualifyingCode === '8') childCount += count;
                      //       return sum + count;
                      //     }, 0);
                      //   } else if (guestData.$ && guestData.$.Count) {
                      //     const count = parseInt(guestData.$.Count, 10);
                      //     guestCount = count;
                      //     if (guestData.$.AgeQualifyingCode === '8') childCount += count;
                      //   }
                      // }

                      if (guestData) {
                        const processGuest = (guest: any) => {
                          const count = guest.$ && guest.$.Count ? parseInt(guest.$.Count, 10) : 0;
                          const age = guest.$ && guest.$.Age ? parseInt(guest.$.Age, 10) : null;

                          guestCount += count;

                          if (guest.$.AgeQualifyingCode === '8' && age !== null) {
                            childCount += count;
                            childAgesMap[age] = (childAgesMap[age] || 0) + count;
                          }
                        };

                        if (Array.isArray(guestData)) {
                          guestData.forEach(processGuest);
                        } else {
                          processGuest(guestData);
                        }
                      }

                      // Build ageNote
                      let ageNote = '';
                      if (childCount > 0) {
                        const ageParts = Object.entries(childAgesMap)
                          .sort((a: any, b: any) => a[0] - b[0]) // sort by age
                          .map(([age, count]) => (count > 1 ? `${count}x${age}` : `${age}`));

                        ageNote = `${childCount} children - ${ageParts.join(', ')}`;
                      }
                      console.log('ageNote1', ageNote);

                      const timeSpan = roomStay.TimeSpan && roomStay.TimeSpan.$ ? roomStay.TimeSpan.$ : {};
                      const roomRate = roomStay.RoomRates && roomStay.RoomRates.RoomRate;
                      const comment = roomStay.Comments;
                      const ratePlanCode = Array.isArray(roomRate)
                        ? roomRate[0].$.RatePlanCode
                        : roomRate && roomRate.$
                        ? roomRate.$.RatePlanCode
                        : '';

                      reservation.roomNo =
                        roomStay.RoomTypes && roomStay.RoomTypes.RoomType && roomStay.RoomTypes.RoomType.$
                          ? roomStay.RoomTypes.RoomType.$.RoomID
                          : '';
                      reservation.arrivalDate = timeSpan.Start;
                      reservation.departureDate = timeSpan.End;
                      reservation.guestCount = guestCount;
                      reservation.childCount = childCount;
                      reservation.reservationInfo = { RatePlanCode: ratePlanCode };
                      reservation.board = this.replaceBoardcode(ratePlanCode, Constants.hotelIntegrations.Casablanca);
                      if (comment && comment.Comment && comment.Comment.$ && comment.Comment.$.Name === 'Service') {
                        reservation.notes = comment.Comment.Text;
                      }
                      if (ageNote) {
                        reservation.notes = reservation.notes ? `${reservation.notes}\n${ageNote}` : ageNote;
                      }
                      const found = this.allHotelReservations.find(
                        (res: any) =>
                          res.hotelReservation.bookingNumber.toString() === reservation.reservationNo.toString() &&
                          res.hotelReservation.roomNo.toString() === reservation.roomNo.toString()
                      );
                      reservation.hotelId = found ? found.hotelReservation.id : null;
                      console.log(
                        'hiii',
                        found,
                        reservation.roomNo.toString(),
                        reservation.reservationNo.toString(),
                        hotelReservation.reservationNo,
                        hotelReservation.guestInfo
                      );
                      // this.hotelReservations.push(reservation);
                      if (this.dateBasedFilter == 'stay') {
                        if (this.checkIfStayDate(reservation)) {
                          this.hotelReservations.push(reservation);
                        }
                      } else {
                        this.hotelReservations.push(reservation);
                      }
                    }
                  } else {
                    // Merge guest count and use first room details
                    let guestCount = 0;
                    let childCount = 0;
                    const childAgesMap: Record<number, number> = {}; // { age: count }
                    let ageNote = '';
                    const roomNos: string[] = [];

                    for (let roomStay of roomStays) {
                      const roomTypes = roomStay.RoomTypes.RoomType;
                      if (Array.isArray(roomTypes)) {
                        roomTypes.forEach(rt => {
                          if (rt.$ && rt.$.RoomID) {
                            roomNos.push(rt.$.RoomID);
                          }
                        });
                      } else if (roomTypes && roomTypes.$ && roomTypes.$.RoomID) {
                        roomNos.push(roomTypes.$.RoomID);
                      }

                      const guestData = roomStay.GuestCounts && roomStay.GuestCounts.GuestCount;
                      // if (guestData) {
                      //   if (Array.isArray(guestData)) {
                      //     guestCount += guestData.reduce((sum, guest) => {
                      //       const count = guest.$.Count ? parseInt(guest.$.Count, 10) : 0;
                      //       if (guest.$.AgeQualifyingCode === '8') childCount += count;
                      //       return sum + count;
                      //     }, 0);
                      //   } else if (guestData.$ && guestData.$.Count) {
                      //     const count = parseInt(guestData.$.Count, 10);
                      //     guestCount += count;
                      //     if (guestData.$.AgeQualifyingCode === '8') childCount += count;
                      //   }
                      // }

                      if (guestData) {
                        const processGuest = (guest: any) => {
                          const count = guest.$ && guest.$.Count ? parseInt(guest.$.Count, 10) : 0;
                          const age = guest.$ && guest.$.Age ? parseInt(guest.$.Age, 10) : null;

                          guestCount += count;

                          if (guest.$.AgeQualifyingCode === '8' && age !== null) {
                            childCount += count;
                            childAgesMap[age] = (childAgesMap[age] || 0) + count;
                          }
                        };

                        if (Array.isArray(guestData)) {
                          guestData.forEach(processGuest);
                        } else {
                          processGuest(guestData);
                        }
                      }

                      // Build ageNote
                      if (childCount > 0) {
                        const ageParts = Object.entries(childAgesMap)
                          .sort((a: any, b: any) => a[0] - b[0]) // sort by age
                          .map(([age, count]) => (count > 1 ? `${count}x${age}` : `${age}`));

                        ageNote = `${childCount} children - ${ageParts.join(', ')}`;
                      }
                      console.log('ageNote2', ageNote, hotelReservation.guestInfo.name);
                    }

                    const roomStay = roomStays[0];
                    const timeSpan = roomStay.TimeSpan && roomStay.TimeSpan.$ ? roomStay.TimeSpan.$ : {};
                    const roomRate = roomStay.RoomRates && roomStay.RoomRates.RoomRate;
                    const comment = roomStay.Comments;
                    const ratePlanCode = Array.isArray(roomRate)
                      ? roomRate[0].$.RatePlanCode
                      : roomRate && roomRate.$
                      ? roomRate.$.RatePlanCode
                      : '';

                    hotelReservation.roomNo = roomNos.join(',');
                    hotelReservation.arrivalDate = timeSpan.Start;
                    hotelReservation.departureDate = timeSpan.End;
                    hotelReservation.guestCount = guestCount;
                    hotelReservation.childCount = childCount;
                    hotelReservation.reservationInfo = { RatePlanCode: ratePlanCode };
                    hotelReservation.board = this.replaceBoardcode(
                      ratePlanCode,
                      Constants.hotelIntegrations.Casablanca
                    );
                    if (comment && comment.Comment && comment.Comment.$ && comment.Comment.$.Name === 'Service') {
                      hotelReservation.notes = comment.Comment.Text;
                    }
                    if (ageNote) {
                      hotelReservation.notes = hotelReservation.notes
                        ? `${hotelReservation.notes}\n${ageNote}`
                        : ageNote;
                    }
                    const found = this.allHotelReservations.find(
                      (res: any) =>
                        res.hotelReservation.bookingNumber.toString() === hotelReservation.reservationNo.toString()
                    );
                    hotelReservation.hotelId = found ? found.hotelReservation.id : null;
                    // this.hotelReservations.push(hotelReservation);
                    if (this.dateBasedFilter == 'stay') {
                      if (this.checkIfStayDate(hotelReservation)) {
                        this.hotelReservations.push(hotelReservation);
                      }
                    } else {
                      this.hotelReservations.push(hotelReservation);
                    }
                  }

                  this.hotelReservations = [...this.hotelReservations];
                }
              }
            }

            console.log('Casablanca2', this.hotelReservations);
            this.setHotelPaginationData();
          },
          err => {
            this.setHotelPaginationData();
            const errMsg =
              err && err.error && err.error.msg
                ? err.error.msg
                : this.translate.instant('HotelReservations.SomethingWentWrong');
            this.snackBar.open(errMsg, '', {
              duration: 2000,
              panelClass: ['snackbar-error']
            });
          }
        )
    );
  }

  getHotelReservationSihot() {
    this.fetchingStartedHotelRes();
    this.subscriptions.push(
      this.pmsIntegrationService
        .getHotelReservationSihot(this.dates.from, this.dates.to, this.dateBasedFilter)
        .subscribe(
          res => {
            if (res) {
              console.log('Sihot1', res);
              for (let item of res) {
                if (item && !item.cancellationdate) {
                  let hotelReservation: any = {};
                  hotelReservation.reservationNo = item.resno;

                  const rooms = Array.isArray(item.ROOMS.ROOM) ? item.ROOMS.ROOM : [item.ROOMS.ROOM];
                  const roomNumbers = rooms.map((reservation: any) => reservation.room);
                  const roomNumbersString = roomNumbers && roomNumbers.length ? roomNumbers.join(',') : '';

                  hotelReservation.roomNo = roomNumbersString;
                  hotelReservation.arrivalDate = item.arrival;
                  hotelReservation.departureDate = item.departure;

                  hotelReservation.guestCount = item.noofpax;
                  hotelReservation.childCount = item.noofchildren;
                  hotelReservation.notes = '';

                  let guestProfile;

                  if (rooms && rooms[0] && rooms[0].PERSON) {
                    const persons = Array.isArray(rooms[0].PERSON) ? rooms[0].PERSON : [rooms[0].PERSON];
                    guestProfile = persons.find((p: any) => p.name1 || p.name2);

                    if (!guestProfile && persons.length) {
                      guestProfile = persons[0];
                    }
                  }

                  if (guestProfile) {
                    hotelReservation.guestInfo = {
                      name: guestProfile.name2 || '',
                      firstName: guestProfile.name1 || '',
                      email: guestProfile.email1 || '',
                      phone: guestProfile.mobile1 || '',
                      guestNotes: ''
                    };
                  }

                  const ratePlanCode = item.RESERVATIONPACKAGES.RESERVATIONPACKAGE.service;
                  hotelReservation.reservationInfo = {
                    RatePlanCode: ratePlanCode
                  };

                  hotelReservation.board = this.replaceBoardcode(ratePlanCode, Constants.hotelIntegrations.Sihot);

                  const foundReservation = this.allHotelReservations.find(
                    (res: any) =>
                      res.hotelReservation.bookingNumber.toString() === hotelReservation.reservationNo.toString()
                  );
                  hotelReservation.hotelId = foundReservation ? foundReservation.hotelReservation.id : null;

                  this.hotelReservations.push(hotelReservation);
                }
              }
            }
            this.hotelReservations = [...this.hotelReservations];
            console.log('Sihot2', this.hotelReservations);
            this.setHotelPaginationData();
          },
          err => {
            this.setHotelPaginationData();
            const errMsg =
              err && err.error && err.error.msg
                ? err.error.msg
                : `${this.translate.instant('HotelReservations.SomethingWentWrong')}`;
            this.snackBar.open(errMsg, '', {
              duration: 2000,
              panelClass: ['snackbar-error']
            });
          }
        )
    );
  }

  placeGuest(reservation: any) {
    if (reservation.hotelId) {
      this.reservationService.getHotelReservation(reservation.hotelId).subscribe(
        hotelResData => {
          if (hotelResData && hotelResData.reservation.length && hotelResData.reservation[0]) {
            this.updateReservation = true;
            const board = hotelResData.board;

            let selectedStayTime: any = null;
            for (let i = 0; i < hotelResData.reservation.length; i++) {
              const match = this.stayTimes.find(st => st.value === hotelResData.reservation[i].stayTime);
              if (match) {
                selectedStayTime = match;
                break;
              }
            }

            // If no exact match found, find the nearest one
            if (!selectedStayTime) {
              const allStayTimes = this.stayTimes.map(st => st.value);
              const reservationStayTimes = hotelResData.reservation.map((res: any) => res.stayTime);

              const nearest = allStayTimes.reduce((prev, curr) => {
                const minDiffCurr = Math.min(...reservationStayTimes.map((t: any) => Math.abs(curr - t)));
                const minDiffPrev = Math.min(...reservationStayTimes.map((t: any) => Math.abs(prev - t)));
                return minDiffCurr < minDiffPrev ? curr : prev;
              });
              selectedStayTime = this.stayTimes.find(st => st.value === nearest) || null;
            }

            const selectedTags: any = [];
            let selectedTagObjects: any = [];

            const dinnerReservations: FormGroup[] = [];
            const lunchReservations: FormGroup[] = [];
            const breakfastReservations: FormGroup[] = [];
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            let allExistingReservation: any = [];

            hotelResData.reservation.forEach((item: any) => {
              const labelStr = item && item.label ? item.label.toString() : '';
              const groupTagIds = labelStr
                .split(',')
                .map((s: string) => s.trim())
                .filter(Boolean)
                .map((v: any) => Number(v))
                .filter((v: number) => !Number.isNaN(v));

              let allSelectedTagIds: number[] = [];
              if (item && Array.isArray(item.tags) && item.tags.length > 0) {
                allSelectedTagIds = item.tags
                  .map((rt: { tag?: { id?: number } }) => (rt && rt.tag ? Number(rt.tag.id) : null))
                  .filter((id: number): id is number => id != null && !Number.isNaN(id));
              }

              const rowLevelTagIds: number[] = allSelectedTagIds.filter(id => groupTagIds.includes(id));

              const globalTags = allSelectedTagIds.filter(id => !groupTagIds.includes(id)); //

              selectedTags.push(globalTags);

              if (selectedTags.length) {
                const selectedTagIds = [...new Set(selectedTags.flat())];

                selectedTagObjects = this.tags.filter(tag => selectedTagIds.includes(tag.id));
              }

              const existingReservation: any = {
                time: new Date(item.reservedFor).toTimeString().slice(0, 5),
                restaurant: item.roomId,
                id: item.id,
                tags: rowLevelTagIds,
                stayTime: item.stayTime,
                table: item.isTablePlan && item.isTablePlan.length ? item.isTablePlan.split(',').map(Number) : []
              };

              allExistingReservation = [...allExistingReservation, existingReservation];

              const date = new Date(item.reservedFor);
              date.setHours(0, 0, 0, 0);
              const reservedTime = new Date(item.reservedFor).getHours();

              if (date.getTime() >= today.getTime()) {
                if (reservedTime < Constants.mealEndTimes.breakfast) {
                  breakfastReservations.push(
                    this.addNewReservationGroup(new Date(item.reservedFor), 'breakfast', existingReservation)
                  );
                } else if (
                  reservedTime >= Constants.mealEndTimes.breakfast &&
                  reservedTime < Constants.mealEndTimes.lunchEnd
                ) {
                  lunchReservations.push(
                    this.addNewReservationGroup(new Date(item.reservedFor), 'lunch', existingReservation)
                  );
                } else {
                  dinnerReservations.push(
                    this.addNewReservationGroup(new Date(item.reservedFor), 'dinner', existingReservation)
                  );
                }
              }
            });

            const placeReservation = {
              name: hotelResData.reservation[0].guestData ? hotelResData.reservation[0].guestData.name : '',
              roomNumber: hotelResData.roomNo,
              reservationNumber: hotelResData.bookingNumber,
              arrivalDate: moment(hotelResData.arrivalDate),
              departureDate: moment(hotelResData.departureDate),
              selectedTags: selectedTagObjects,
              numberOfPersons: hotelResData.reservation[0].peopleCount,
              numberOfKids: hotelResData.reservation[0].children,
              numberOfHighChairs: hotelResData.reservation[0].highChairs,
              incompatibilities:
                hotelResData.reservation[0].guestData &&
                hotelResData.reservation[0].guestData.intolerance &&
                hotelResData.reservation[0].guestData.intolerance != 'null'
                  ? JSON.parse(hotelResData.reservation[0].guestData.intolerance)
                  : null,
              notes: hotelResData.reservation[0].notes,
              stayTime: selectedStayTime,
              firstName: hotelResData.reservation[0].guestData ? hotelResData.reservation[0].guestData.firstName : '',
              email: hotelResData.reservation[0].guestData ? hotelResData.reservation[0].guestData.email : '',
              phone: hotelResData.reservation[0].guestData ? hotelResData.reservation[0].guestData.phone : '',
              board: board,
              groupTags: hotelResData.groupTags,
              hotelSystem: hotelResData.hotelSystem,
              guestNotes: hotelResData.reservation[0].guestData ? hotelResData.reservation[0].msg : '',
              bookingId: hotelResData.bookingId,
              hotelId: hotelResData.id,
              guestId: hotelResData.reservation[0].guestData.id
            };

            this.paginatedReservations = [
              {
                reservationNo: placeReservation.reservationNumber,
                guestInfo: {
                  name: placeReservation.name,
                  firstName: placeReservation.firstName,
                  email: placeReservation.email,
                  phone: placeReservation.phone,
                  guestNotes: placeReservation.guestNotes
                },
                roomNo: placeReservation.roomNumber,
                arrivalDate: placeReservation.arrivalDate,
                departureDate: placeReservation.departureDate,
                guestCount: placeReservation.numberOfPersons,
                childCount: placeReservation.numberOfKids,
                board: placeReservation.board,
                notes: placeReservation.notes,
                bookingId: placeReservation.bookingId,
                reservationInfo: {
                  RatePlanCode: placeReservation.groupTags
                },
                hotelId: reservation.hotelId
              }
            ];
            this.setGuestValue(placeReservation);

            const existingReservationsFormControl = (this.reservationForm as FormArray).controls;
            const existingReservations = existingReservationsFormControl.map(control => control as FormGroup);
            const allReservations: any = [
              ...existingReservations,
              ...dinnerReservations,
              ...lunchReservations,
              ...breakfastReservations
            ];

            this.sortReservationAndFilterReservations(allReservations, allExistingReservation);

            this.previousArrivalDate = new Date(this.reservationFormGroup.value.arrivalDate);
            this.previousArrivalDate.setHours(0, 0, 0, 0);
            this.previousDepartureDate = new Date(this.reservationFormGroup.value.departureDate);
            this.previousDepartureDate.setHours(0, 0, 0, 0);
          }
        },
        err => {
          console.log('No reservation found.');
        }
      );
    } else {
      const placeReservation = {
        name: reservation.guestInfo.name,
        roomNumber: reservation.roomNo,
        reservationNumber: reservation.reservationNo,
        arrivalDate: moment(reservation.arrivalDate),
        departureDate: moment(reservation.departureDate),
        numberOfPersons: reservation.guestCount,
        numberOfKids: reservation.childCount ? reservation.childCount : 0,
        board: reservation.board,
        notes: reservation.notes,
        firstName: reservation.guestInfo.firstName,
        email: reservation.guestInfo.email,
        phone: reservation.guestInfo.phone,
        guestNotes: reservation.guestInfo.guestNotes,
        bookingId: reservation.bookingId,
        groupTags: reservation.reservationInfo ? reservation.reservationInfo.RatePlanCode : '',
        stayTime: this.settings.stayTime
      };
      this.setGuestValue(placeReservation);
      this.checkIsSelectedTimeIntervalValid();
    }
  }

  setGuestValue(placeReservation: any) {
    Object.entries(placeReservation).forEach(([key, value]) => {
      if (this.reservationFormGroup.get(key)) {
        this.reservationFormGroup.get(key).setValue(value);
      }
    });
    (this.reservationForm as FormArray).clear();
    this.callPlaced = true;
  }

  callCopyAllItems(i: any, mealType: string) {
    this.copyAllItems = true;

    // Find the first row of the given mealType
    // const firstElement = this.reservationForm.value.find((item: any) => item.mealType === mealType);
    // if (!firstElement) return; // If no such row, exit

    const firstElement = this.reservationForm.value[i];

    // Iterate through all rows and update only matching mealType rows
    this.reservationForm.value.forEach((element: any, index: any) => {
      if (element.mealType === mealType && element.resIndex && element.resIndex != 1) {
        this.updateFormGroupValue('reservations', { listOfTimes: firstElement.listOfTimes }, index);
        this.updateFormGroupValue('reservations', { listOfRestaurants: firstElement.listOfRestaurants }, index);
        this.updateFormGroupValue('reservations', { listOfTables: firstElement.listOfTables }, index);
        this.updateFormGroupValue('reservations', { time: firstElement.time }, index);
        this.updateFormGroupValue('reservations', { restaurant: firstElement.restaurant }, index);
        // this.updateFormGroupValue('reservations', { reservationStayTime: firstElement.reservationStayTime }, index);
        // this.updateFormGroupValue('reservations', { reservationTags: firstElement.reservationTags }, index);
        (async () => {
          if (firstElement.table && firstElement.table.length > 0) {
            this.updateFormGroupValue('reservations', { tableLoader: true }, index);

            // Check availability for all selected tables
            const availabilityChecks = await Promise.all(
              firstElement.table.map((tableId: any) => this.checkTableAvailability(firstElement.time, tableId, index))
            );

            // If any table is not available, show an error
            const isAnyTableUnavailable = availabilityChecks.includes(false);

            if (isAnyTableUnavailable) {
              this.updateFormGroupValue(
                'reservations',
                { errorMessage: 'One or more selected tables are not free' },
                index
              );
            } else {
              this.updateFormGroupValue('reservations', { errorMessage: '' }, index);
            }

            this.updateFormGroupValue('reservations', { table: firstElement.table }, index);
            this.updateFormGroupValue('reservations', { tableLoader: false }, index);
          } else {
            this.updateFormGroupValue('reservations', { table: [] }, index);
          }
        })();
      }
    });
  }

  checkTableAvailability(time: any, table: any, index: any): Promise<boolean> {
    return new Promise(resolve => {
      const selectedRestaurantId = this.reservationForm.value[index].restaurant;
      const data = this.reservationFormGroup.value;
      const res = this.reservationForm.value[index];
      const stayMin = this.getRowStayMinutes(res);
      this.subscriptions.push(
        this.reservationService
          .checkFreeTables(
            res.date,
            time,
            data.numberOfPersons,
            stayMin,
            true,
            true,
            res.reservationId || '',
            selectedRestaurantId
          )
          .subscribe(response => {
            if (response) {
              const selectedRestaurant = response[0];
              const availableTables = selectedRestaurant.tables.filter(
                (element: any) =>
                  element.isFree && parseInt(this.reservationFormGroup.get('numberOfPersons').value) <= element.seats
              );
              const tableExist = availableTables.some((item: any) => item.id === table);
              resolve(tableExist);
            }
          })
      );
    });
  }

  getTimes() {
    this.defaultTime = moment().format('HH:mm');
    this.times = [];
    let tStart = 0;
    const interval = 15;
    for (let i = 0; tStart < 24 * 60; i++) {
      const hh = Math.floor(tStart / 60); // getting hours of day in 0-24 format
      const mm = tStart % 60; // getting minutes of the hour in 0-55 format

      const timeObj = {
        time: ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2),
        isClosed: true
      };
      this.times.push(timeObj);

      const hhNext = Math.floor((tStart + interval) / 60); // getting hours of day in 0-24 format
      const mmNext = (tStart + interval) % 60; // getting minutes of the hour in 0-55 format
      const dateObjNext = new Date();
      dateObjNext.setHours(hhNext);
      dateObjNext.setMinutes(mmNext);

      const dateObj = new Date();
      dateObj.setHours(hh);
      dateObj.setMinutes(mm);

      const defaultTimeDateObj = new Date();
      const defaultTimeSplit = this.defaultTime.split(':');
      defaultTimeDateObj.setHours(+defaultTimeSplit[0]);
      defaultTimeDateObj.setMinutes(+defaultTimeSplit[1]);

      if (dateObj < defaultTimeDateObj && dateObjNext > defaultTimeDateObj) {
        const defaultTimeObj = {
          time: this.defaultTime,
          isClosed: false
        };
      }

      tStart = tStart + interval;
    }
    // Check opening hours and append Closed label to times which are closed
    this.clientService
      .getOpeningHourOfDay(moment(this.reservationFormGroup.value.date).format('YYYY-MM-DD'))
      .takeUntil(this.ngUnsubscribe)
      .subscribe(async (openingHours: any) => {
        if (openingHours.length) {
          // Loop trough all entries to check time
          await openingHours.reduce(
            (prev: any, oh: any) =>
              prev.then(async () => {
                this.times = await this._checkTimesWithOpeningHours(oh.tFrom, oh.tTo, oh.closed);
              }),
            Promise.resolve()
          );
        } else {
          // No opening hours for this day, so its closed
          const newTimes = await this.times.map((time: any) => {
            time.isClosed = true;
            return time;
          });
          this.times = [...newTimes];
        }
      });
  }

  private _checkTimesWithOpeningHours(tFrom: string, tTo: string, closed: boolean = false) {
    const from = moment(tFrom, 'HH:mm');
    const to = moment(tTo, 'HH:mm');

    return Promise.all(
      this.times.map((t: any) => {
        if (t.isClosed && !closed) {
          const time = moment(t.time, 'HH:mm');
          if (from.isBefore(to)) {
            t.isClosed = !(
              time.isBetween(from, to) ||
              time.format('HH:mm') === from.format('HH:mm') ||
              time.format('HH:mm') === to.format('HH:mm')
            );
          } else {
            t.isClosed = time.isBetween(to, from);
          }
          return t;
        } else if (!t.isClosed && closed) {
          const time = moment(t.time, 'HH:mm');
          if (from.isBefore(to)) {
            t.isClosed =
              time.isBetween(from, to) ||
              time.format('HH:mm') === from.format('HH:mm') ||
              time.format('HH:mm') === to.format('HH:mm');
          } else {
            t.isClosed = !time.isBetween(to, from);
          }
          return t;
        } else {
          // Time oh was alredy set
          return t;
        }
      })
    );
  }

  changeBoardOption() {
    if (this.reservationFormGroup.value.arrivalDate && this.reservationFormGroup.value.departureDate) {
      // Clear existing reservations and insert in correct order
      (this.reservationForm as FormArray).clear();
      this.checkIsSelectedTimeIntervalValid();
    }
  }

  checkIsSelectedTimeIntervalValid(): void {
    let reservations = this.reservationForm as FormArray;
    let arrivalDate = new Date(this.reservationFormGroup.value.arrivalDate);
    arrivalDate.setHours(0, 0, 0, 0);
    let departureDate = new Date(this.reservationFormGroup.value.departureDate);
    departureDate.setHours(0, 0, 0, 0);
    const board = this.reservationFormGroup.value.board;

    if (reservations.length > 0) {
      if (arrivalDate.getTime() > this.previousArrivalDate.getTime()) {
        this.removeReservationsBefore(arrivalDate);
      } else if (arrivalDate.getTime() < this.previousArrivalDate.getTime()) {
        this.addElementsToReservations(arrivalDate, subDays(this.previousArrivalDate, 1), board);
      }

      if (departureDate.getTime() < this.previousDepartureDate.getTime()) {
        this.removeReservationsAfter(departureDate);
      } else if (departureDate.getTime() > this.previousDepartureDate.getTime()) {
        this.addElementsToReservations(addDays(this.previousDepartureDate, 1), departureDate, board);
      }
    } else {
      if (arrivalDate && departureDate && departureDate.getTime() > arrivalDate.getTime()) {
        this.addElementsToReservations(arrivalDate, departureDate, board);
      }
    }
    this.previousArrivalDate = new Date(this.reservationFormGroup.value.arrivalDate);
    this.previousArrivalDate.setHours(0, 0, 0, 0);
    this.previousDepartureDate = new Date(this.reservationFormGroup.value.departureDate);
    this.previousDepartureDate.setHours(0, 0, 0, 0);
  }

  /**
   * Adds reservations for **future dates only**, in correct order:
   * 1. All breakfast rows for all future dates
   * 2. All lunch rows for all future dates (if full board)
   * 3. All dinner rows for all future dates
   */
  addElementsToReservations(startDate: Date, endDate: Date, board: string) {
    let currentDate = new Date(startDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dinnerReservations: FormGroup[] = [];
    const lunchReservations: FormGroup[] = [];
    const breakfastReservations: FormGroup[] = [];
    while (currentDate.getTime() <= endDate.getTime()) {
      if (currentDate.getTime() >= today.getTime()) {
        // Only add future dates
        if (board === 'HP' || board === 'VP') {
          dinnerReservations.push(this.addNewReservationGroup(new Date(currentDate), 'dinner'));
        }
        if (board === 'VP') {
          lunchReservations.push(this.addNewReservationGroup(new Date(currentDate), 'lunch'));
        }
        if (board === 'FR' || board === 'HP' || board === 'VP') {
          breakfastReservations.push(this.addNewReservationGroup(new Date(currentDate), 'breakfast'));
        }
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    // this.insertReservationsByMealType([...dinnerReservations, ...lunchReservations, ...breakfastReservations]);

    // [...dinnerReservations, ...lunchReservations, ...breakfastReservations].forEach(res =>
    //   (this.reservationForm as FormArray).push(res)
    // );

    const existingReservationsFormControl = (this.reservationForm as FormArray).controls;
    const existingReservations = existingReservationsFormControl.map(control => control as FormGroup);
    const allReservations: any = [
      ...existingReservations,
      ...dinnerReservations,
      ...lunchReservations,
      ...breakfastReservations
    ];
    this.sortReservationAndFilterReservations(allReservations);
  }

  sortReservationAndFilterReservations(allReservations: any, allExistingReservation: any = []) {
    allReservations.sort((a: any, b: any) => {
      const mealOrderA = this.mealTypeOrder[a.value.mealType] || 99;
      const mealOrderB = this.mealTypeOrder[b.value.mealType] || 99;

      if (mealOrderA !== mealOrderB) {
        return mealOrderA - mealOrderB;
      }
      const dateA = new Date(a.value.date).getTime();
      const dateB = new Date(b.value.date).getTime();

      return dateA - dateB;
    });

    (this.reservationForm as FormArray).clear();

    allReservations.forEach((res: any) => {
      const mealType = res.get('mealType').value;
      const date = res.get('date').value;
      date.setHours(0, 0, 0, 0);
      const arrivalDate = new Date(this.reservationFormGroup.value.arrivalDate);
      arrivalDate.setHours(0, 0, 0, 0);
      const departureDate = new Date(this.reservationFormGroup.value.departureDate);
      departureDate.setHours(0, 0, 0, 0);

      // let exempt = false;
      // if (date.getTime() == arrivalDate.getTime()) {
      //   exempt = mealType !== 'dinner' && mealType !== 'lunch';
      // }
      // if (date.getTime() == departureDate.getTime()) {
      //   exempt = mealType !== 'breakfast';
      // }

      // Get policy based on meal type
      const policy =
        mealType === 'breakfast' ? this.breakfastPolicy : mealType === 'lunch' ? this.lunchPolicy : this.dinnerPolicy;

      const isArrival = date.getTime() === arrivalDate.getTime();
      const isDeparture = date.getTime() === departureDate.getTime();
      const isMiddle = !isArrival && !isDeparture;

      let exempt = false;

      if (isMiddle) {
        // Middle days are always shown
        exempt = false;
      } else {
        // Arrival and Departure logic based on policy
        switch (policy) {
          case 0: // Arrival only
            exempt = isDeparture; // Hide departure, show arrival
            break;

          case 1: // Departure only
            exempt = isArrival; // Hide arrival, show departure
            break;

          case 2: // Both
            exempt = false; // Show arrival & departure
            break;

          case 3: // No on edges
            exempt = isArrival || isDeparture; // Hide edges, show middle
            break;

          default:
            exempt = false; // Default: show all
            break;
        }
      }

      res.get('exempt').setValue(exempt);
      console.log('mealType:', mealType, '| date:', date.toDateString(), '| policy:', policy, '| exempt:', exempt);

      (this.reservationForm as FormArray).push(res);
    });

    this.updateFirstEditableForMealType(allExistingReservation);
  }

  // To find the last index of a given mealType
  findLastMealTypeIndex(mealType: string) {
    const existingReservations = this.reservationForm.value;
    let lastIndex = -1;
    existingReservations.forEach((res: any, index: any) => {
      if (res.mealType === mealType) {
        lastIndex = index;
      }
    });
    return lastIndex;
  }

  /**
   * Removes reservations before a given date.
   */
  removeReservationsBefore(date: Date) {
    const reservations = this.reservationForm as FormArray;
    for (let i = reservations.length - 1; i >= 0; i--) {
      if (new Date(reservations.at(i).value.date).getTime() < date.getTime()) {
        this.cancelExistingReservation(i);
        reservations.removeAt(i);
        this.updateFirstEditableForMealType();
      }
    }
  }

  /**
   * Removes reservations after a given date.
   */
  removeReservationsAfter(date: Date) {
    const reservations = this.reservationForm as FormArray;
    for (let i = reservations.length - 1; i >= 0; i--) {
      if (new Date(reservations.at(i).value.date).getTime() > date.getTime()) {
        this.cancelExistingReservation(i);
        reservations.removeAt(i);
        this.updateFirstEditableForMealType();
      }
    }
  }

  removeReservationAtIndex(i: any) {
    const reservations = this.reservationForm as FormArray;
    this.cancelExistingReservation(i);
    reservations.removeAt(i);
    this.updateFirstEditableForMealType();
  }

  cancelExistingReservation(i: any) {
    const row = this.reservationForm.value[i];
    if (row && row.reservationId) {
      this.canceledReservations.push(row.reservationId);
    }
  }
  // updateFirstEditableForMealType(allExistingReservation: any = []) {
  //   this.breakfastCounter = 1;
  //   this.lunchCounter = 1;
  //   this.dinnerCounter = 1;
  //   let defaultTime = null;

  //   const processedMealTypes: string[] = [];

  //   for (let i = 0; i < this.reservationForm.value.length; i++) {
  //     const row = this.reservationForm.value[i];
  //     if (!row.exempt) {
  //       this.updateFormGroupValue('reservations', { resIndex: this.getMealTypeCounter(row.mealType) }, i);

  //       // If the mealType is not in the processed array, it's the first occurrence
  //       if (!processedMealTypes.includes(row.mealType)) {
  //         this.updateFormGroupValue('reservations', { isEditable: true }, i);
  //         processedMealTypes.push(row.mealType); // Add the mealType to the processed list
  //         if (!row.time) {
  //           if (row.mealType === 'breakfast') {
  //             const foundTime = this.times.find(t => t.time === '08:00');
  //             defaultTime = foundTime ? foundTime.time : null;
  //           } else if (row.mealType === 'lunch') {
  //             const foundTime = this.times.find(t => t.time === '13:00');
  //             defaultTime = foundTime ? foundTime.time : null;
  //           } else if (row.mealType === 'dinner') {
  //             const foundTime = this.times.find(t => t.time === '19:00');
  //             defaultTime = foundTime ? foundTime.time : null;
  //           }
  //           this.updateFormGroupValue('reservations', { time: defaultTime }, i);
  //         }
  //       } else {
  //         this.updateFormGroupValue('reservations', { isEditable: false }, i);
  //       }
  //     }
  //     if (allExistingReservation && allExistingReservation.length > 0) {
  //       if (row.reservationId) {
  //         const foundReservation = allExistingReservation.find((res: any) => res.id === row.reservationId);
  //         if (foundReservation) {
  //           this.searchFreeTables(i, foundReservation.table);
  //         }
  //       }
  //     }
  //   }
  // }

  updateFirstEditableForMealType(allExistingReservation: any[] = []) {
    this.breakfastCounter = 1;
    this.lunchCounter = 1;
    this.dinnerCounter = 1;

    const fa = this.reservationFormGroup.get('reservations') as FormArray;
    if (!fa) return;

    const stOpt = this.stayTimes.find(o => o.value === this.settings.stayTime) || {
      name: this.formatStayTimeLabel(this.settings.stayTime),
      value: this.settings.stayTime
    };

    const topStayCtrl = this.reservationFormGroup.get('reservationStayTime');
    if (topStayCtrl) {
      topStayCtrl.setValue(stOpt, { emitEvent: false });
    }

    const processedMealTypes: string[] = [];

    for (let i = 0; i < fa.length; i++) {
      const rowGroup = fa.at(i) as FormGroup;
      const row = rowGroup ? rowGroup.value : null;
      if (!row.exempt) {
        this.updateFormGroupValue('reservations', { resIndex: this.getMealTypeCounter(row.mealType) }, i);

        if (processedMealTypes.indexOf(row.mealType) === -1) {
          this.updateFormGroupValue('reservations', { isEditable: true }, i);
          processedMealTypes.push(row.mealType);

          if (!row.time) {
            const configured = this.getDefaultTimeFor(row.mealType);
            const list = row.listOfTimes && row.listOfTimes.length ? row.listOfTimes : this.times || [];
            const chosen = this.pickAvailableTime(configured, list);
            this.updateFormGroupValue('reservations', { time: chosen }, i);
          }
        } else {
          this.updateFormGroupValue('reservations', { isEditable: false }, i);
        }

        // const stayCtrl = this.reservationFormGroup.get('reservationStayTime');
        // const mainStay = stayCtrl && stayCtrl.value ? stayCtrl.value : stOpt;
        // if (!row.reservationStayTime) {
        //   this.updateFormGroupValue('reservations', { reservationStayTime: mainStay }, i);
        // }

        const tagsCtrl = this.reservationFormGroup.get('reservationTags');
        const mainTags = tagsCtrl && tagsCtrl.value ? tagsCtrl.value : '';
        if (!row.reservationTags) {
          this.updateFormGroupValue('reservations', { reservationTags: mainTags }, i);
        }
      }
      if (allExistingReservation && allExistingReservation.length && row.reservationId) {
        const found = allExistingReservation.find((r: any) => r.id === row.reservationId);
        if (found) this.searchFreeTables(i, found.table);
      }
    }
  }

  private getDefaultTimeFor(mealType: 'breakfast' | 'lunch' | 'dinner'): string {
    switch (mealType) {
      case 'breakfast':
        return this.settings.breakfastTime;
      case 'lunch':
        return this.settings.lunchTime;
      case 'dinner':
        return this.settings.dinnerTime;
    }
  }

  private pickAvailableTime(target: string, listOfTimes: Array<{ time: string; isClosed?: boolean }>): string | null {
    // exact configured time
    const exact = listOfTimes.find(t => t.time === target);
    if (exact) return exact.time;

    // else pick the first open time
    const open = listOfTimes.find(t => !t.isClosed);
    if (open) return open.time;

    // nothing open? just use the first entry if it exists
    return listOfTimes.length ? listOfTimes[0].time : null;
  }

  getMealTypeCounter(mealType: string): number {
    if (mealType === 'breakfast') {
      return this.breakfastCounter++;
    } else if (mealType === 'lunch') {
      return this.lunchCounter++;
    } else if (mealType === 'dinner') {
      return this.dinnerCounter++;
    }
    return 0;
  }

  editReservation(i: any) {
    this.updateFormGroupValue('reservations', { isEditable: true }, i);
    this.searchFreeTables(i);
  }

  replaceGuestReservation(index: any) {
    const element = this.reservationForm.value[index];
    const allDataList = {
      listOfRestaurants: element.listOfRestaurants,
      listOfTimes: element.listOfTimes
    };
    const reservedFor = format(element.date, 'YYYY-MM-DD') + ' ' + element.time;
    this.reservationService
      .fetchExistingGuestReservation(reservedFor, this.reservationFormGroup.value.stayTime, element.table)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        (reservation: any) => {
          if (reservation) {
            const modalRef = this.modalService.open(ReplaceGuestReservationComponent, {
              windowClass: 'onboarding-modal',
              size: 'lg'
            });
            modalRef.componentInstance.reservation = reservation;
            modalRef.componentInstance.allDataList = allDataList;
            modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
              this.reservationService.replaceGuestReservation(receivedEntry).then((response: any) => {
                this.searchFreeTables(index, element.table);
                const snackBarRef = this.snackBar.open(`${this.translate.instant('HotelReservations.Success')}`, 'Ok', {
                  duration: 3000,
                  panelClass: ['snackbar-success']
                });
                modalRef.close();
              });
            });
          }
        },
        err => {
          console.error('Error fetching reservation', err);
        }
      );
  }

  onTableChanged(index: any) {
    const element = this.reservationForm.value[index];
    // Find if any selected table is unavailable
    const isAnyTableUnavailable = element.table.some((tableId: any) => {
      const foundTable = element.listOfTables.find((item: any) => item.table.id === tableId);
      return foundTable.isNotAvailable;
    });

    if (isAnyTableUnavailable) {
      this.updateFormGroupValue('reservations', { errorMessage: 'One or more selected tables are not free' }, index);
    } else {
      this.updateFormGroupValue('reservations', { errorMessage: '' }, index);
    }
  }

  replaceBoardcode(ratePlanCode: any, hotelIntegrations: any) {
    let boardCode = '';
    if (ratePlanCode) {
      if (hotelIntegrations == Constants.hotelIntegrations.ASA) {
        const replacements: any = {
          BB: 'FR',
          HB: 'HP',
          FB: 'VP'
        };
        boardCode = replacements[ratePlanCode] || '';
      } else if (hotelIntegrations == Constants.hotelIntegrations.Oracle) {
        const replacements: any = {
          DAILY_ADV: 'HP',
          HP: 'HP'
        };
        boardCode = replacements[ratePlanCode] || '';
      }
      if (!boardCode && this.allRatePlans && this.allRatePlans.length > 0) {
        const found = this.allRatePlans.find((plan: any) => plan.ratePlanCodeName.trim() === ratePlanCode.trim());
        boardCode = found ? found.mealName : '';
      }
    }
    return boardCode;
  }

  toggleExpandRow(row: any) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  fetchColor(board: string): string {
    const meal = this.mealOptions.find(option => option.value === board);
    return meal ? meal.color : 'gray';
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  setHotelPaginationData() {
    this.loadingHotelRes = false;
    this.updatePagination();
  }

  fetchingStartedHotelRes() {
    this.loadingHotelRes = true;
    this.hotelReservations = [];
    this.currentPage = 1;
    this.updatePagination();
    this.initForm();
    (this.reservationForm as FormArray).clear();
    this.callPlaced = false;
    this.updateReservation = false;
  }

  // Function to insert reservations after the last occurrence of their type
  // insertReservationsByMealType(newReservations: FormGroup[]) {
  //   newReservations.forEach(newRes => {
  //     const mealType = newRes.get('mealType').value;
  //     const date = newRes.get('date').value;
  //     date.setHours(0, 0, 0, 0);
  //     const arrivalDate = new Date(this.reservationFormGroup.value.arrivalDate);
  //     arrivalDate.setHours(0, 0, 0, 0);
  //     const departureDate = new Date(this.reservationFormGroup.value.departureDate);
  //     departureDate.setHours(0, 0, 0, 0);

  //     if (date.getTime() == arrivalDate.getTime()) {
  //       console.log('firstday', date);
  //       if (mealType !== 'dinner') {
  //         newRes.get('exempt').setValue(true);
  //       }
  //     }
  //     if (date.getTime() == departureDate.getTime()) {
  //       console.log('lastday', date);
  //       if (mealType !== 'breakfast') {
  //         newRes.get('exempt').setValue(true);
  //       }
  //     }
  //     const lastIndex = this.findLastMealTypeIndex(mealType);

  //     if (lastIndex === -1) {
  //       (this.reservationForm as FormArray).push(newRes);
  //     } else {
  //       (this.reservationForm as FormArray).insert(lastIndex + 1, newRes);
  //     }
  //   });
  // }

  // isFirstRowEmpty(mealType: string): boolean {
  //   const firstRow = this.reservationForm.value.find((item: any) => item.mealType === mealType);
  //   return !firstRow.table;
  // }

  // isFirstRowOfMealType(mealType: string, index: number): boolean {
  //   return this.reservationForm.value.findIndex((item: any) => item.mealType === mealType) === index;
  // }

  // displayFnName(guest: any): string {
  //   if (guest) {
  //     this.reservationFormGroup.get('incompatibilities').setValue(JSON.parse(guest.intolerance));
  //     return guest.name;
  //   }
  // }

  // new filter section

  filterOptions: FilterOption[] = [
    { id: 1, label: 'Option A' },
    { id: 2, label: 'Option B' },
    { id: 3, label: 'Option C' }
  ];

  selectedIds: Set<number> = new Set();

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  toggleSelection(id: number): void {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
    this.updatePagination();
  }

  getPMSProductData() {
    this.reservationService
      .getPMSProductData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (resp: any) => {
          if (resp.success) {
            let customProductFilter = [];
            if (resp['data'] && resp['data'].length) {
              customProductFilter = resp['data'].map((item: any) => {
                return {
                  value: item.mealName,
                  label: item.ratePlanCodeName,
                  color: 'gray'
                };
              });
            }
            this.flattenedMealOptions = [...this.mealOptions, ...customProductFilter];
          }
        },
        error => {
          this.snackBar.open(this.translate.instant('PMSProductIntegration.SomethingWentWrong'), 'Close', {
            duration: 2000
          });
        }
      );
  }

  mealGroupedFilterList: any[] = [];
  flattenedMealOptions: any[] = [];

  clearSearch() {
    this.searchTerm = '';
    // this.searchMealPlan = null;
    this.currentPage = 1;
    this.updatePagination();
  }

  updatePagination() {
    // 1. Sort by arrival date
    this.hotelReservations.sort(function(a: any, b: any) {
      return new Date(a.arrivalDate).getTime() - new Date(b.arrivalDate).getTime();
    });

    // 2. Setup pagination
    this.totalPages = Math.ceil(this.hotelReservations.length / this.pageSize);
    if (this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages || 1;
    }

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    // 3. Paginate base
    this.paginatedReservations = this.hotelReservations.slice(start, end).map(function(r: any) {
      r.expanded = false;
      return r;
    });

    // 4. Filter
    const hasSearchTerm = typeof this.searchTerm === 'string' && this.searchTerm.trim().length > 0;
    const hasMealPlan = typeof this.searchMealPlan === 'string' && this.searchMealPlan;

    if (hasSearchTerm || this.searchMealPlan) {
      const self = this;

      this.paginatedReservations = this.paginatedReservations.filter(function(item: any) {
        let matchesSearchTerm = true;
        let matchesMealPlan = true;

        //  Text filter
        if (hasSearchTerm) {
          const lowerTerm = self.searchTerm.toLowerCase();
          const guestFirstName =
            item && item.guestInfo && item.guestInfo.firstName ? item.guestInfo.firstName.toLowerCase() : '';
          const guestLastName = item && item.guestInfo && item.guestInfo.name ? item.guestInfo.name.toLowerCase() : '';
          matchesSearchTerm = guestFirstName.indexOf(lowerTerm) !== -1 || guestLastName.indexOf(lowerTerm) !== -1;
        }

        //  Meal Plan filter
        if (hasMealPlan) {
          matchesMealPlan = item.board === self.searchMealPlan;
        }
        return matchesSearchTerm && matchesMealPlan;
      });
    }

    if (this.showOnlyNewReservations) {
      this.paginatedReservations = this.paginatedReservations.filter(
        (res: any) => res.hotelId === null || res.hotelId === undefined
      );
    }
  }

  getPMSMealSettings() {
    this.reservationService
      .getPMSMealSettings()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (resp: any) => {
          if (resp.success) {
            const hasArray = (resp as any).data && Array.isArray((resp as any).data) && (resp as any).data.length > 0;
            const d: any = hasArray ? (resp as any).data[0] : (resp as any);
            if (d.createdAt) {
              this.breakfastPolicy = d.breakfastServedAt;
              this.lunchPolicy = d.lunchServedAt;
              this.dinnerPolicy = d.dinnerServedAt;
            }
            this.settings = {
              breakfastTime: d.breakfastTime || this.settings.breakfastTime,
              lunchTime: d.lunchTime || this.settings.lunchTime,
              dinnerTime: d.dinnerTime || this.settings.dinnerTime,
              stayTime: +d.stayTime || this.settings.stayTime,
              filter: d.filter || this.settings.filter
            };
            this.dateBasedFilter = this.settings.filter;
            this.checkDateFilterSetDate();

            const opt = this.stayTimes.find(o => o.value === this.settings.stayTime) || {
              name: this.formatStayTimeLabel(this.settings.stayTime),
              value: this.settings.stayTime
            };
            if (this.reservationFormGroup && this.reservationFormGroup.get('stayTime')) {
              this.reservationFormGroup.get('stayTime').setValue(opt, { emitEvent: false });
            }
          }
        },
        error => {
          this.snackBar.open(this.translate.instant('PMSProductIntegration.SomethingWentWrong'), 'Close', {
            duration: 2000
          });
        }
      );
  }

  private formatStayTimeLabel(minutes: number): string {
    if (!minutes && minutes !== 0) return '';
    if (minutes % 60 === 0) {
      const hours = minutes / 60;
      return hours === 1
        ? `1 ${this.translate.instant('HotelReservations.Hour')}`
        : `${hours} ${this.translate.instant('HotelReservations.Hours')}`;
    }
    return `${minutes} ${this.translate.instant('HotelReservations.Minutes')}`;
  }

  checkIfStayDate(hotelReservation: any) {
    const arrivalDate = new Date(hotelReservation.arrivalDate);
    arrivalDate.setHours(0, 0, 0, 0);

    const departureDate = new Date(hotelReservation.departureDate);
    departureDate.setHours(0, 0, 0, 0);

    const fromDate = new Date(this.dates.from);
    fromDate.setHours(0, 0, 0, 0);

    const toDate = new Date(this.dates.to);
    toDate.setHours(0, 0, 0, 0);

    if (arrivalDate <= toDate && departureDate >= fromDate) {
      return true;
    } else {
      return false;
    }
  }

  checkIfArrivalDate(hotelReservation: any) {
    const arrivalDate = new Date(hotelReservation.arrivalDate);
    arrivalDate.setHours(0, 0, 0, 0);

    const fromDate = new Date(this.dates.from);
    fromDate.setHours(0, 0, 0, 0);

    const toDate = new Date(this.dates.to);
    toDate.setHours(0, 0, 0, 0);

    return arrivalDate >= fromDate && arrivalDate <= toDate;
  }

  checkDateFilterSetDate() {
    if (this.dateBasedFilter == 'stay') {
      this.dates.from = this.dates.to = this.stayDate;
    }
  }
}
